var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('Header'),_c('div',{staticClass:"container mx-auto py-4"},[_c('breadcrumb'),_c('div',{staticClass:"md:grid md:grid-cols-5 md:gap-4 mt-2"},[_c('account-menu'),_c('router-view',{staticClass:"col-span-4"})],1)],1),_c('Footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }